export default {
    USER_LOGIN: "USER_LOGIN",
    USER_LOGOUT: "USER_LOGOUT",
    
    SET_USER_TOKEN: "SET_USER_TOKEN",
};